export interface NoData {
  initial: boolean;
  filtered: boolean;
}

export const getNoData = (
  isLoading: boolean,
  hasData: boolean,
  hasInitialFilters: boolean,
): NoData => {
  const noData = { initial: false, filtered: false };
  if (hasData || isLoading) return noData;

  if (hasInitialFilters) {
    noData.initial = true;
  } else {
    noData.filtered = true;
  }
  return noData;
};
